import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { SERVICES } from "../site.config";

const EXTRA_SERVICES = [
  "Insurance Work",
  "New Build Flooring",
  "Property Refurbishments",
  "Expert Flooring Advice",
  "Underlay Supply & Fitting",
  "Repairs & Patching",
  "Same-Day Quote Visits",
  "All Work Guaranteed",
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="section-pad bg-moffat-cream relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="font-script text-3xl text-moffat-red leading-none">
              Products & services
            </p>
            <h2 className="font-display text-4xl sm:text-5xl text-moffat-navy mt-3 uppercase max-w-xl">
              Everything under<br />one roof.
            </h2>
          </div>
          <p className="text-moffat-muted text-base max-w-sm md:text-right leading-relaxed">
            No job too big or too small — from a single room to full refurbs,
            new builds and commercial fit-outs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {SERVICES.map((s, idx) => (
            <article
              key={s.key}
              data-testid={`service-card-${s.key}`}
              className="group relative bg-white rounded-sm overflow-hidden border border-moffat-line hover:shadow-2xl transition-all hover:-translate-y-1.5"
            >
              <div className="relative aspect-square overflow-hidden bg-moffat-navyDeep">
                <img
                  src={s.image}
                  alt={s.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-display text-lg md:text-xl text-moffat-navy uppercase leading-tight">
                  {s.name}
                </h3>
                <p className="mt-2 text-sm text-moffat-muted leading-relaxed">
                  {s.blurb}
                </p>
                <a
                  href="#quote"
                  data-testid={`service-card-cta-${s.key}`}
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-moffat-red uppercase tracking-wider group/cta"
                >
                  Free quote
                  <ArrowRight
                    size={16}
                    className="transition-transform group-hover/cta:translate-x-1"
                  />
                </a>
              </div>
            </article>
          ))}
        </div>

        {/* Extra services as checklist */}
        <div className="mt-10 bg-moffat-navy text-white rounded-sm p-6 md:p-8 border-l-4 border-moffat-red">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <p className="font-display text-lg md:text-xl uppercase">
              We also handle
            </p>
            <p className="text-xs text-white/60 font-semibold uppercase tracking-widest">
              Domestic · Commercial · Landlords
            </p>
          </div>
          <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
            {EXTRA_SERVICES.map((item) => (
              <div key={item} className="flex items-center gap-2 text-sm">
                <Check size={14} strokeWidth={3} className="text-moffat-red flex-shrink-0" />
                <span className="font-medium">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
